import React, { useState, useEffect } from 'react';
import { Modal, Table, Form, Button, Spinner } from 'react-bootstrap';
import { toast } from 'react-toastify';
import moment from 'moment';
import * as api from '~/Services/Service';

const ModalLiberacao = ({ visivel, prevenda, onFechar, onLiberado }) => {
  const [pendencias, setPendencias] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pendenciaSelecionada, setPendenciaSelecionada] = useState(null);
  const [justificativa, setJustificativa] = useState('');
  const [liberando, setLiberando] = useState(false);

  useEffect(() => {
    if (!visivel || !prevenda) {
      setPendencias([]);
      setPendenciaSelecionada(null);
      setJustificativa('');
      return;
    }
    let ativo = true;
    const carregar = async () => {
      setLoading(true);
      try {
        const resp = await api.consultarPendenciasPrevenda(prevenda);
        if (ativo) {
          setPendencias(resp && resp.itens ? resp.itens : []);
        }
      } catch (err) {
        if (ativo) {
          const msg = err && err.message ? err.message : 'Erro ao carregar pendências.';
          toast.error(msg);
        }
      } finally {
        if (ativo) setLoading(false);
      }
    };
    carregar();
    return () => { ativo = false; };
  }, [visivel, prevenda]);

  const handleLiberar = async () => {
    if (!justificativa || justificativa.trim().length < 10) {
      toast.warn('A justificativa deve ter no mínimo 10 caracteres.');
      return;
    }
    setLiberando(true);
    try {
      await api.liberarComissaoRetida({ prevenda, justificativa: justificativa.trim() });
      toast.success('Comissão liberada com sucesso!');
      onLiberado();
    } catch (err) {
      const msg = err && err.message ? err.message : 'Erro ao liberar comissão.';
      toast.error(msg);
    } finally {
      setLiberando(false);
    }
  };

  return (
    <Modal show={visivel} onHide={onFechar} size="lg" centered>
      <Modal.Header closeButton style={{ backgroundColor: '#0747a6', color: '#fff' }}>
        <Modal.Title>Liberar Comissão</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {loading ? (
          <div className="text-center">
            <Spinner animation="border" size="sm" /> Carregando pendências...
          </div>
        ) : (
          <>
            <Table striped bordered hover size="sm" responsive>
              <thead>
                <tr className="text-center">
                  <th>Data</th>
                  <th>Tipo</th>
                  <th>Título</th>
                  <th>Usuário</th>
                </tr>
              </thead>
              <tbody>
                {pendencias.map((p) => (
                  <tr
                    key={`pend-${p.prevenda}-${p.tp}-${p.data}-${p.titulo}`}
                    onClick={() => setPendenciaSelecionada(p)}
                    style={{
                      cursor: 'pointer',
                      backgroundColor: pendenciaSelecionada === p ? '#d4edda' : '',
                    }}
                  >
                    <td className="text-center">{moment(p.data).format('DD/MM/YYYY')}</td>
                    <td>{p.tipo}</td>
                    <td>{p.titulo}</td>
                    <td>{p.nome_usuario}</td>
                  </tr>
                ))}
                {pendencias.length === 0 && (
                  <tr>
                    <td colSpan={4} className="text-center text-muted">
                      Nenhuma pendência encontrada.
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>

            {pendenciaSelecionada && pendenciaSelecionada.texto && (
              <Form.Group className="mb-3">
                <Form.Label>Detalhes</Form.Label>
                <Form.Control as="textarea" rows={3} readOnly value={pendenciaSelecionada.texto} />
              </Form.Group>
            )}

            <Form.Group>
              <Form.Label>Justificativa (mín. 10 caracteres)</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                value={justificativa}
                onChange={(e) => setJustificativa(e.target.value)}
                placeholder="Informe a justificativa para liberação..."
              />
            </Form.Group>
          </>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onFechar} disabled={liberando}>
          Cancelar
        </Button>
        <Button variant="primary" onClick={handleLiberar} disabled={liberando || loading}>
          {liberando ? 'Liberando...' : 'Liberar Comissão'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalLiberacao;
